import { render, staticRenderFns } from "./summary-report-card.vue?vue&type=template&id=e4770922"
import script from "./summary-report-card.vue?vue&type=script&lang=js"
export * from "./summary-report-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports